import { render, staticRenderFns } from "./ForgetForm.vue?vue&type=template&id=4431d82e&"
import script from "./ForgetForm.vue?vue&type=script&lang=ts&"
export * from "./ForgetForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports